import {RestResource} from '../rest'
import {PERSON_SERVER} from '../server'
import {athubAxios} from "../../util/athub-axios";

const person = new RestResource({server: PERSON_SERVER, resource: 'person'});

person.fetchByRedis = (params, config) => {
    let url = `${PERSON_SERVER}/redis`;
    return new Promise((resolve, reject) => {
        athubAxios.postByJson(url, params, config).then(responseBody => {
            if (responseBody.data.code == 200) {
                resolve(responseBody.data.data);
            }
        })
    });
}

person.getByPersonId = (orgId, personId, config) => {
    let url = `${PERSON_SERVER}/person/org/${orgId}/personid/${personId}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url, config).then(responseBody => {
            if (responseBody.data.code === 200) {
                resolve(responseBody.data.data);
            } else {
                reject(responseBody.data.message);
            }
        });
    });
};

export default person;
